<div class="relative z-[3]">
  <div
    class="bg-primary-500 text-white rounded-sm cursor-pointer inline-flex items-center px-lg py-sm"
    (click)="toggleQuickAction()">
    <lib-add-icon iconClass="size-5 text-white" />
    <p
      class="text-sm font-medium text-white ms-sm"
      [class.hidden]="isSideMenuCollapsed()">
      {{ 'quick_action_label' | transloco }}
    </p>
  </div>

  @if (isQuickActionOpen()) {
    @if (quickActionItems().length === 1) {
      <div
        class="absolute top-[2.5rem] ltr:left-0 rtl:right-0 z-1 shadow-xl"
        libClickOutSide
        (clickOutside)="onClickOutside()">
        <ng-container [ngTemplateOutlet]="quickActionItems()[0].child" />
      </div>
    } @else {
      <div
        class="w-[12.5rem] absolute top-[2.5rem] ltr:left-0 rtl:right-0 bg-white rounded-md p-lg z-1 shadow-xl"
        libClickOutSide
        (clickOutside)="onClickOutside()">
        <ul class="flex flex-col gap-sm">
          @for (item of quickActionItemsWithState(); track item.label) {
            <div class="relative">
              <li
                class="mb-xs flex items-center justify-between cursor-pointer rounded-md hover:bg-neutral-50"
                (click)="onQuickActionItemClick($index)">
                <div class="flex items-center py-sm px-md">
                  <ng-container [ngTemplateOutlet]="item.icon" />
                  <p class="text-xs font-medium text-neutral-700 ps-sm">
                    {{ item.label | transloco }}
                  </p>
                </div>
                <lib-chevron-right-icon iconClass="size-5 text-neutral-500" />
              </li>
              @if (item.isChildOpen) {
                <div
                  class="absolute top-0 ltr:left-[12rem] rtl:right-[12rem] w-[18.75rem] bg-white">
                  <ng-container [ngTemplateOutlet]="item.child" />
                </div>
              }
            </div>
          }
        </ul>
      </div>
    }
  }
</div>
